// extracted by mini-css-extract-plugin
module.exports = {"regulatoryHeader":"_abbd05d","regulatoryText":"_7f64048","regulatoryIcons":"_80a82d0","logoFr":"_86b30d9","eighteenPlusFr":"_6c12414"};